<template>
  <div class="flex items-center w-full gap-4" :class="{ 'justify-between': label }">
    <p
      v-if="label"
      class=""
      :class="[light ? 'font-light tracking-wide text-base' : 'font-normal text-lg']">
      {{ label }}
    </p>
    <div
      class="relative inline-block h-6 w-10 cursor-pointer [-webkit-tap-highlight-color:_transparent]"
      @click="toggleState"
      :class="{ 'opacity-50 cursor-not-allowed': disable }">
      <!-- Background track -->
      <span
        class="absolute inset-0 m-auto h-2 w-full rounded-full transition-colors"
        :class="getTrackClass()"></span>
      <!-- Toggle thumb -->
      <span
        class="absolute inset-y-0 w-4 h-4 m-auto transition-all rounded-full"
        :class="getThumbClass()"
        :style="getThumbPosition()">
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
const data = defineModel<boolean | undefined>();

const props = withDefaults(
  defineProps<{
    label?: string;
    name: string;
    disable?: boolean;
    light?: boolean;
  }>(),
  {}
);

const toggleState = () => {
  if (props.disable) return;

  if (data.value === undefined) {
    data.value = false;
  } else if (data.value === false) {
    data.value = true;
  } else {
    data.value = undefined;
  }
};

const getTrackClass = () => {
  if (data.value === true) {
    return 'bg-theme-500';
  } else if (data.value === false) {
    return 'bg-red-300';
  } else {
    return 'bg-gray-300';
  }
};

const getThumbClass = () => {
  if (data.value === true) {
    return 'bg-theme-600';
  } else if (data.value === false) {
    return 'bg-red-500';
  } else {
    return 'bg-gray-500';
  }
};

const getThumbPosition = () => {
  if (data.value === true) {
    return { left: '1.5rem' }; // Far right
  } else if (data.value === false) {
    return { left: '0rem' }; // Far left
  } else {
    return { left: '0.75rem' }; // Center
  }
};
</script>
